import { type Account } from '../../cache/Account';
import { TvAccountsManager } from '../Managers/TvAccountsManager';
import { type QuotesCallback } from '../charting_library';
import { type IHaveAccount, TvQuoteSubsciptionItem } from './TvQuoteSubsciptionItem';

export class TvQuoteSubscribtionsContainer implements IHaveAccount {
    private readonly subscriptionsMap = new Map<string, TvQuoteSubsciptionItem>();
    private curAccount: Account;

    constructor () {
        this.setCurrentAccount(TvAccountsManager.getDefaultAccount());
    }

    public subscribeQuotes (symbols: string[], fastSymbols: string[], onRealtimeCallback: QuotesCallback, listenerGUID: string): void {
        if (!this.subscriptionsMap.has(listenerGUID)) {
            const newSubscriptionItem = new TvQuoteSubsciptionItem(this);
            this.subscriptionsMap.set(listenerGUID, newSubscriptionItem);
        }

        const subscriptionItem = this.subscriptionsMap.get(listenerGUID);
        subscriptionItem.subscribe(symbols, fastSymbols, onRealtimeCallback);
    }

    public unsubscribeQuotes (listenerGUID: string): void {
        if (!this.subscriptionsMap.has(listenerGUID)) {
            return;
        }
        const subscriptionItem = this.subscriptionsMap.get(listenerGUID);
        subscriptionItem.unsubscribe();
        this.subscriptionsMap.delete(listenerGUID);
    }

    public getAccount (): Account {
        return this.curAccount;
    }

    public setCurrentAccount (account: Account): void {
        this.curAccount = account;
        this.subscriptionsMap.forEach((subscriptionItem) => {
            subscriptionItem.sendRealtimeData();
        });
    }
}
